import { render } from "./RecruitmentManagement.vue?vue&type=template&id=cd4e8da0&scoped=true"
import script from "./RecruitmentManagement.vue?vue&type=script&lang=js"
export * from "./RecruitmentManagement.vue?vue&type=script&lang=js"

import "./RecruitmentManagement.vue?vue&type=style&index=0&id=cd4e8da0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd4e8da0"]])

export default __exports__